import { Modal, Button } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';

type Props = {
  isOpen: boolean;
  value: string;
  onClose: () => void;
  onSubmit: () => void;
  isValueMapped?: boolean;
};

export const DeleteCustomFieldValueModal = ({
  isOpen,
  value,
  onClose,
  onSubmit,
  isValueMapped,
}: Props) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName } = useAccountingSoftwareName();

  return (
    <Modal
      iconName="cross"
      iconVariant="alert"
      isOpen={isOpen}
      actions={[
        <Button
          variant="secondaryNeutral"
          text={t('customFields.settings.modals.deletion.cancel')}
          onClick={() => onClose()}
          key="secondary"
        />,
        <Button
          variant="primaryAlert"
          text={t('customFields.settings.modals.deletion.submit')}
          onClick={() => onSubmit()}
          key="primary"
        />,
      ]}
      title={t('customFields.settings.modals.deletion.title')}
    >
      {isValueMapped
        ? t(
            'bookkeep.integrations.settings.analyticalFieldMapping.deleteAnalyticalFieldValue',
            { integration: accountingSoftwareName },
          )
        : t('customFields.settings.modals.deletion.description', {
            name: value,
          })}
    </Modal>
  );
};
